import type { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

import type { Coefficient } from '@shared-types/coefficient.types';

export const overallClubMaleCols: ColDef[] = [
  {
    field: 'points',
    headerName: 'points',
    headerTooltip: 'how_points_calculated',
    tooltipComponentParams: { openModal: true },
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints >= c.overallRanking?.nationalAssociationPoints,
    },
  },
  {
    field: 'na',
    headerName: 'na_contr',
    headerTooltip: 'na_contribution',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.nationalAssociationPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints <= c.overallRanking?.nationalAssociationPoints,
    },
  },
];

export const overallClubFemaleCols: ColDef[] = [
  {
    field: 'tcc',
    headerName: 'points',
    headerTooltip: 'total_club_coefficient',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints >= c.overallRanking?.nationalAssociationPoints,
    },
  },
  {
    field: 'ac',
    headerName: 'na_contr',
    headerTooltip: 'womens_associtation_coefficient_info',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.nationalAssociationPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints <= c.overallRanking?.nationalAssociationPoints,
    },
  },
];

const overallNationalCols: ColDef[] = [
  {
    field: 'points',
    headerName: 'points',
    headerTooltip: 'how_points_calculated',
    tooltipComponentParams: { openModal: true },
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.overallRanking?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
    context: {
      getBold: (c: Coefficient) =>
        c.overallRanking && c.overallRanking.totalPoints >= c.overallRanking?.nationalAssociationPoints,
    },
  },
];

export const overallNationalMaleCols: ColDef[] = [
  ...overallNationalCols,
  {
    field: 'clubs',
    headerName: 'clubs',
    headerTooltip: 'club_still_participating',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) =>
      (c.overallRanking?.numberOfTeamsStillInPlaying ?? 0) / (c.overallRanking?.numberOfTeams ?? 0),
    cellRenderer: ({ data: c }: ICellRendererParams<Coefficient>) =>
      [c.overallRanking?.numberOfTeamsStillInPlaying, c.overallRanking?.numberOfTeams].filter(Boolean).join('/'),
  },
];

export const overallNationalFemaleCols: ColDef[] = [...overallNationalCols];
